import { doc, onSnapshot } from "firebase/firestore";
import { db, sendError } from "./firebase";

import { Badge } from '@awesome-cordova-plugins/badge';
import { Capacitor } from "@capacitor/core";

const version=1
    const build=80

var snapshotListener: Function | null = null;
const listeners: CallableFunction[] = [];
var lastSnapshot: any = undefined;

export function getCurrentVersion(){
    return version+"."+build;
}

export function getNewVersion(delimeter:string="-"){
    if(lastSnapshot !== undefined){
        return lastSnapshot.version+delimeter+lastSnapshot.build;
    }
    return undefined;
}

function ifNewVersion(){
    if(lastSnapshot !== undefined){
        if(version < lastSnapshot.version || build<lastSnapshot.build){
            return true;
        }
    }
    return false;
}

export function registerVersionSnapshotListener() {
    if (snapshotListener !== null) {
        return;
    }
    //console.log("register VersionSnapshotListener");
    const docRef = doc(db, 'global/', "version");
    snapshotListener = onSnapshot(docRef, (data: any) => {
        lastSnapshot = data.data();
        listeners.forEach(callback => {
            callback(ifNewVersion());
        });
    }, (err) => {
        console.log("onVersionChange error => " + err.message);
        sendError(err.message);
    })
}

export async function unregisterVersionSnapshotListener() {
    if (snapshotListener !== null) {
        //console.log("unregister VersionSnapshotListener");
        await snapshotListener();
        snapshotListener = null;
    }
}

export async function addVersionListener(callback: CallableFunction) {
    listeners.push(callback);
    if (lastSnapshot  !== undefined) {
        callback(ifNewVersion());
    }
}



